// ظلال 3D Neu قوية موحّدة للأزرار الملوّنة في صفحة الموافقات (بروز عميق + حافة ضوئية علوية).
export const RAISED3D =
  "0 9px 0 rgba(0,0,0,.24), 0 18px 30px rgba(0,0,0,.24), inset 0 3px 0 rgba(255,255,255,.6), inset 0 -8px 16px rgba(0,0,0,.28)";
export const PRESSED3D =
  "0 2px 0 rgba(0,0,0,.24), inset 0 5px 12px rgba(0,0,0,.4), inset 0 2px 0 rgba(255,255,255,.3)";
